module.exports = __webpack_public_path__ + "static/enterprise-circle-c6b70e7a639275709c10502d43206c3c.png";